// extracted by mini-css-extract-plugin
export default {"engagement_icon":"default_icon_engagement_icon__kczDW","engagement_icon_img":"default_icon_engagement_icon_img__S8inF"};